import { DOCUMENT } from '@angular/core';
import { Directive, Inject, Input, OnInit } from '@angular/core';
import { environment } from '@environments/environment';

@Directive({
  selector: '[dynamicScript]',
  standalone: true
})
export class DynamicScriptDirective implements OnInit {
  @Input('dynamicScript') dynamicScript: string = '';

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    if (this.dynamicScript)
      this.loadDynamicScript();
  }

  loadDynamicScript() {
    const dynamicScriptUrl = environment.ASSETS_ENDPOINT + this.dynamicScript;
    if (!this.document.querySelector(`script[src="${dynamicScriptUrl}"]`)) {
      const script = this.document.createElement('script');
      script.src = dynamicScriptUrl;
      script.defer = true;
      this.document.head.appendChild(script);
    }
  }
}
